module.exports = __webpack_public_path__ + "static/media/donet-development-training.00f1adf7.png";